import {
  METRICTABLE_DEVICES,
  CONSOLE_DIGITAL_REVENUE_DEVICES,
  CONSOLE_MAU_AND_LIFETIMEPLAYERS_DEVICES,
  CONSOLE_PHYSICAL_REVENUE_DEVICES,
  CONSOLE_JAPAN_SALES_DEVICES,
  PCCONSOLE_DEVICE_MAP_COMBINE,
  METRICTABLE_KPITRENDS_WEEK_DEVICES,
  CONSOLE_AMPERE_PLATFORM,
} from './constant';
import { SEGMENT_CASCADER } from '@intelligence/_config/components/filters/segmentCascader';
import { PCConsolePageId } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/type';
import { SEGMENT_PLATFORM_CASCADER } from '@intelligence/_config/components/filters/platformCascader';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import {
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
  TopchartPageId,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import {
  initFormatter,
  getAdditionalArr,
} from '@intelligence/components/Form/utils/formatter';
import { getMetricsTablePlatformGroupConfig } from './metricsTablePlatformGroups';

export const getDetailStatsSubTabName = (
  entityType: string,
  pageId: PCConsolePageId,
) => {
  if (pageId === TopchartPageId.PCConsoleMetricsTable) {
    return '';
  }
  if (
    pageId === TopchartPageId.MetricsTable ||
    pageId === TopchartPageId.LifeTimePlayers
  ) {
    return entityType === 'pc' ? 'pcu' : 'digitalRevenue';
  }
  if (pageId === TopchartPageId.MAU) {
    return 'mau';
  }
  if (pageId === TopchartPageId.PCU) {
    return 'pcu';
  }
  if (pageId === TopchartPageId.DigitalRevenue) {
    return 'digitalRevenue';
  }
  if (pageId === TopchartPageId.PhysicalRevenue) {
    return 'physicalRevenue';
  }
  if (pageId === TopchartPageId.SteamSales) {
    return 'gamalytic__est_revenue';
  }
  return '';
};

const deviceOptionsCfg = {
  consoleDigitalRevenue: {
    options: CONSOLE_DIGITAL_REVENUE_DEVICES,
    value: CONSOLE_DIGITAL_REVENUE_DEVICES.map((t) => t.value),
  },
  combineDigitalRevenue: {
    options: METRICTABLE_DEVICES,
    value: METRICTABLE_DEVICES.map((t) => t.value),
  },
  mau: {
    options: CONSOLE_MAU_AND_LIFETIMEPLAYERS_DEVICES,
    value: CONSOLE_MAU_AND_LIFETIMEPLAYERS_DEVICES.map((t) => t.value),
  },
  ampereMau: {
    options: CONSOLE_AMPERE_PLATFORM,
    value: CONSOLE_AMPERE_PLATFORM.map((t) => t.value),
  },
  combineMAU: {
    options: [
      { value: 'PC', text: 'PC' },
      ...CONSOLE_MAU_AND_LIFETIMEPLAYERS_DEVICES,
    ],
    value: [
      { value: 'PC', text: 'PC' },
      ...CONSOLE_MAU_AND_LIFETIMEPLAYERS_DEVICES,
    ].map((t) => t.value),
  },
  lifetimeplayers: {
    options: CONSOLE_MAU_AND_LIFETIMEPLAYERS_DEVICES,
    value: CONSOLE_MAU_AND_LIFETIMEPLAYERS_DEVICES.map((t) => t.value),
  },
  physicalRevenue: {
    options: CONSOLE_PHYSICAL_REVENUE_DEVICES,
    value: CONSOLE_PHYSICAL_REVENUE_DEVICES.map((t) => t.value),
  },
  combinephysicalRevenue: {
    options: [{ value: 'PC', text: 'PC' }, ...CONSOLE_PHYSICAL_REVENUE_DEVICES],
    value: [
      { value: 'PC', text: 'PC' },
      ...CONSOLE_PHYSICAL_REVENUE_DEVICES,
    ].map((t) => t.value),
  },
  japansales: {
    options: CONSOLE_JAPAN_SALES_DEVICES,
    value: CONSOLE_JAPAN_SALES_DEVICES.map((t) => t.value),
  },
  combineMetricTable: {
    options: METRICTABLE_DEVICES,
    value: METRICTABLE_DEVICES.map((t) => t.value),
  },
  combineKPITrendsWeekPlatform: {
    options: METRICTABLE_KPITRENDS_WEEK_DEVICES,
    value: METRICTABLE_KPITRENDS_WEEK_DEVICES.map((t) => t.value),
  },
};

export const getDeviceConfig = (
  type: PCConsolePageId | string,
  entityType?: string,
) => {
  const typeName = type?.toLocaleLowerCase();
  switch (typeName) {
    case TopchartPageId.DigitalRevenue?.toLocaleLowerCase():
      if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
        return deviceOptionsCfg.combineDigitalRevenue;
      }
      return deviceOptionsCfg.consoleDigitalRevenue;
    case TopchartPageId.MAU?.toLocaleLowerCase():
      if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
        return deviceOptionsCfg.combineMAU;
      }
      return deviceOptionsCfg.mau;
    case TopchartPageId.AmpereMau?.toLocaleLowerCase():
      return deviceOptionsCfg.ampereMau;
    case TopchartPageId.LifeTimePlayers?.toLocaleLowerCase():
      return deviceOptionsCfg.lifetimeplayers;
    case TopchartPageId.PhysicalRevenue?.toLocaleLowerCase():
      if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
        return deviceOptionsCfg.combinephysicalRevenue;
      }
      return deviceOptionsCfg.physicalRevenue;
    case TopchartPageId.JapanSales?.toLocaleLowerCase():
      return deviceOptionsCfg.japansales;
    case TopchartPageId.PCConsoleMetricsTable?.toLocaleLowerCase():
    case TopchartPageId.PCConsoleDataBrainCalibration?.toLocaleLowerCase():
      return deviceOptionsCfg.combineMetricTable;
    case TopchartPageId.PCConsoleKPITrendsPlatform?.toLocaleLowerCase():
      return deviceOptionsCfg.combineKPITrendsWeekPlatform;
    default:
      return { value: undefined, options: [] };
  }
};

export const getDeviceOptionByType = (
  type: PCConsolePageId,
  entityType?: string,
) => getDeviceConfig(type, entityType)?.options;

export const getDeviceValuesByPageId = (
  type: PCConsolePageId,
  entityType?: string,
) => getDeviceConfig(type, entityType)?.value;

export const getPlatformDeviceCascaderOptions = (options: any[] = []) => {
  const platformOrder = ['PC', 'PlayStation', 'Xbox', 'Nintendo'];
  const grouped = options.reduce((result: Record<string, any[]>, item: any) => {
    const value = String(item?.value || '');
    const platform = platformOrder.find((key) => value === key || value.startsWith(key));
    if (platform) result[platform] = [...(result[platform] || []), item];
    return result;
  }, {});
  return platformOrder
    .filter((platform) => grouped[platform]?.length)
    .map((platform) => ({ value: platform, text: platform, children: grouped[platform] }));
};

/** device参数特殊处理传到后端 */
export const getCombineTopchartDeviceParams = (deviceValues: string[]) => {
  const platforms = {
    PC: {
      npd: ['PC'],
      mscience: ['PC'],
      famitsu: [],
      newzoo: ['PC'],
      metacritic: ['PC'],
    },
    PlayStation: {
      npd: ['PlayStation 4', 'PlayStation 5'],
      mscience: ['PlayStation'],
      famitsu: ['PS5', 'PS4'],
      newzoo: ['PlayStation 4', 'PlayStation 5'],
      metacritic: ['PS4', 'PS5'],
    },
    Xbox: {
      npd: ['Xbox One', 'Xbox Series X|S'],
      mscience: ['Xbox'],
      famitsu: [],
      newzoo: ['Xbox One', 'Xbox Series X|S'],
      metacritic: ['XOne', 'XS X|S'],
    },
    Nintendo: {
      npd: ['Nintendo Wii U', 'Nintendo Switch'],
      mscience: ['Nintendo'],
      famitsu: ['Switch'],
      newzoo: [],
      metacritic: ['Wii U', 'NS'],
    },
  } as any;
  const device: {
    npd: string[];
    mscience: string[];
    famitsu: string[];
    newzoo: string[];
    metacritic: string[];
  } = {
    npd: [],
    mscience: [],
    famitsu: [],
    newzoo: [],
    metacritic: [],
  };
  let selectDevice = deviceValues;
  if (!deviceValues?.length || deviceValues?.includes('All')) {
    selectDevice = ['PC', 'PlayStation', 'Xbox', 'Nintendo'];
  }

  Object.keys(platforms).forEach((platform) => {
    if (selectDevice?.includes(platform)) {
      device.npd.push(...platforms[platform].npd);
      device.mscience.push(...platforms[platform].mscience);
      device.famitsu.push(...platforms[platform].famitsu);
      device.newzoo.push(...platforms[platform].newzoo);
      device.metacritic.push(...platforms[platform].metacritic);
    }
  });
  return device;
};

export const getAggregatedDevicesValues = (devices: string[]): string[] => {
  if (!Array.isArray(devices)) return [];
  const aggregatedDevicesSet: Set<string> = new Set();
  for (const device of devices) {
    const aggregatedDevice = PCCONSOLE_DEVICE_MAP_COMBINE[device] || device;
    if (!aggregatedDevice) continue;
    aggregatedDevicesSet.add(aggregatedDevice);
  }
  return Array.from(aggregatedDevicesSet);
};

export const getPCConsoleMetricValues = (metrics) => {
  if (!Array.isArray(metrics)) {
    return {};
  }
  const result = metrics?.filter(Boolean)?.reduce((accumulator, item: any) => {
    // const metricValue = item?.metricValue ?? item?.dataSource;
    const metricValue = ['pcu', 'acu', 'gamalytic__pcu', 'gamalytic__acu']?.includes(item?.value)
      ? (item?.value?.startsWith('gamalytic__') ? 'gamalytic' : 'steamcharts')
      : item?.metricValue ?? item?.dataSource;
    const isSteamPrice =
      metricValue === 'vginsights' && item?.value === 'est_price';
    if (accumulator[metricValue]) {
      accumulator[metricValue].push(item?.value);
    } else {
      accumulator[metricValue] = [item?.value];
    }
    if (isSteamPrice) {
      accumulator[metricValue].push('est_price_time');
    }
    return accumulator;
  }, {});

  const firstKey = Object.keys(result)?.[0];
  const firstValue = result?.[firstKey]?.[0];
  return {
    order_metric: firstValue,
    order_source: firstKey,
    source_metrics: result,
  };
};

export const getTopMarketsRegions = (tableList: any[]) => {
  /** 取排除total的Top5 */
  const tableExceptTotal = tableList.filter(
    (t: any) =>
      t.market !== 'Total' &&
      t.market !== 'global_wo_china' &&
      t.market !== 'global',
  );
  const markets: string[] = [];
  tableExceptTotal.forEach((t: any) => {
    if (t?.market) {
      markets.push(t?.market);
    }
  });
  return markets.slice(0, 5);
};

// 判断第一个有数据的
export const findFirstMatchingElement = (arrayA: any[], arrayB: any[]) => {
  return arrayB?.find((bElement) =>
    arrayA?.some((aSubArray) => {
      const metricList = aSubArray?.metric_value_list?.map(
        (item: any) => item.metric,
      );
      return metricList?.includes(bElement);
    }),
  );
};

export const getPlatformCascaderOptions = (
  defaultValue: Record<string, string[]>,
  configRender: Record<string, string[]>,
) => {
  const config = initFormatter(SEGMENT_CASCADER, {});
  const { children = [] } = config[0] || {};
  return {
    ...config[0],
    children: getAdditionalArr(children, config[0], defaultValue, {}),
    ...configRender,
  };
};

export const getPlatformsCascaderOptions = (
  defaultValue: Record<string, string[]>,
  configRender: Record<string, string[]>,
) => {
  const config = initFormatter(SEGMENT_PLATFORM_CASCADER, {});
  const { children = [] } = config[0] || {};
  return {
    ...config[0],
    children: getAdditionalArr(children, config[0], defaultValue, {}),
    ...configRender,
  };
};

const PLATFORM_ICON_MAP: Record<string, string> = {
  PC: 'pc',
  PlayStation: 'playstation',
  Xbox: 'xbox',
  Nintendo: 'nintendo',
};

const addCascaderParents = (
  items: any[],
  parent: any,
  dataSource?: any,
): any[] =>
  items.map((item) => {
    const result = { ...item, parent };
    const currentDataSource = dataSource || result;
    result.cascaderDataSource = currentDataSource;
    result.cascaderDataSourceLabel = currentDataSource.label;
    result.cascaderDataSourceLabelKey = currentDataSource.labelKey;
    result.cascaderDataSourceValue = currentDataSource.value;
    result.children = addCascaderParents(
      item.children || [],
      result,
      currentDataSource,
    );
    return result;
  });

/**
 * MetricsTable 专用三级平台选项。
 * 仅增加 Platform 展示分组，最终可选叶子的 value 沿用原配置，保证接口参数不变。
 */
export const getMetricsTablePlatformsCascaderOptions = (
  _defaultValue: Record<string, string[]>,
  configRender: Record<string, any>,
) => {
  const config = initFormatter(SEGMENT_PLATFORM_CASCADER, {});
  const root: any = {
    ...config[0],
    hasThirdLevel: true,
    subCategory: 'dbi_platform',
    groupWidth: 400,
    childWidth: 210,
    thirdLevelWidth: 250,
    thirdLevelUnavailableTextKey: 'dbi_device_dimension_data_unavailable',
  };
  const children = (root.children || []).map((source: any) => {
    const groupConfig = getMetricsTablePlatformGroupConfig(source);
    if (!groupConfig) return source;

    const platforms = Object.entries(groupConfig).map(([platformName, leafValues]) => ({
      key: platformName,
      label: platformName,
      value: platformName,
      icon: PLATFORM_ICON_MAP[platformName],
      children: leafValues
        .map((leafValue) => source.children?.find((item: any) => item.value === leafValue))
        .filter(Boolean),
    }));
    return {
      ...source,
      children: platforms,
      selectableChildrenCount: platforms.reduce(
        (count, platform) => count + platform.children.length,
        0,
      ),
    };
  });

  return {
    ...root,
    children: addCascaderParents(children, root),
    ...configRender,
  };
};

/** Console Data：仅保留 Alinea Analytics 平台分组（PC / PlayStation / Xbox） */
export const CONSOLE_DATA_PLATFORM_CASCADER_DEFAULT: Record<string, string[]> = {
  alinea: ['PC', 'PlayStation', 'Xbox'],
};

const CONSOLE_DATA_ALINEA_SHORTCUT_LABELS = ['PC', 'PlayStation', 'Xbox'];

export const getAlineaPlatformsCascaderOptions = (
  defaultValue: Record<string, string[]> = CONSOLE_DATA_PLATFORM_CASCADER_DEFAULT,
  configRender: Record<string, any> = {},
) => {
  const fullOptions = getPlatformsCascaderOptions(
    { [filterKeyMap.CASCADER]: defaultValue },
    configRender,
  );
  const children = (fullOptions.children || []).filter(
    (item: any) => item?.key === 'alinea',
  );
  const shortcutOptions = (fullOptions.shortcutOptions || []).filter((item: any) =>
    CONSOLE_DATA_ALINEA_SHORTCUT_LABELS.includes(item?.label),
  );
  return {
    ...fullOptions,
    children,
    shortcutOptions,
  };
};

// 示例用法
// const A = [[1, 2], [3, 4], [5, 6]];
// const B = [7, 8, 3, 9];

// const result = findFirstMatchingElement(A, B);
// console.log(result); // 输出 3（第一个在A子数组中找到的B元素）
